import React from 'react';
import cn from 'classnames';
import styles from './preview-pages.module.css';

export interface PreviewBrandingImagePage {
  name: string;
  href: string;
}

interface PreviewPageProps {
  href: string;
  name: string;
}

const PreviewPage: React.FC<PreviewPageProps> = ({ href, name }) => (
  <li>
    <a href={href} target="_blank" rel="noreferrer">
      {name}
      <i className="glyphicon glyphicon-new-window" />
    </a>
  </li>
);

interface PreviewPagesProps {
  previewBrandingImagePages: PreviewBrandingImagePage[];
}

/**
 * PreviewPages component to display a list of preview pages.
 * @param {PreviewPagesProps} props - The props for the component.
 * @returns {JSX.Element} The PreviewPages component.
 */
export const PreviewPages: React.FC<PreviewPagesProps> = ({ previewBrandingImagePages }) => (
  <ol className={cn('list-unstyled', styles.pageList)}>
    {previewBrandingImagePages.map((page, index) => (
      <PreviewPage key={index} href={page.href} name={page.name} />
    ))}
  </ol>
);